// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unauthorized-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f8d7da;
  }
  
  .unauthorized-box {
    border: 1px solid #f5c2c7;
    background-color: #f8d7da;
    color: #721c24;
    padding: 20px;
    text-align: center;
    border-radius: 5px;
  }
  
  .unauthorized-title {
    font-size: 2em;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .unauthorized-message {
    font-size: 1.2em;
  }
  `, "",{"version":3,"sources":["webpack://./src/MyComponents/UnAuth/UnAuthorized.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB","sourcesContent":[".unauthorized-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #f8d7da;\n  }\n  \n  .unauthorized-box {\n    border: 1px solid #f5c2c7;\n    background-color: #f8d7da;\n    color: #721c24;\n    padding: 20px;\n    text-align: center;\n    border-radius: 5px;\n  }\n  \n  .unauthorized-title {\n    font-size: 2em;\n    font-weight: bold;\n    margin-bottom: 10px;\n  }\n  \n  .unauthorized-message {\n    font-size: 1.2em;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
